// extracted by mini-css-extract-plugin
module.exports = {"gris":"estructura_gris__4BYWs","negre":"estructura_negre__F3aLR"};